import * as D3Shape from "d3-shape";
import * as D3Scale from "d3-scale";
import * as D3Array from "d3-array";
import * as D3Drag from "d3-drag";
import * as D3Selection from "d3-selection";
import * as D3Time from "d3-time";

export default {
  ...D3Shape,
  ...D3Scale,
  ...D3Array,
  ...D3Drag,
  ...D3Selection,
  ...D3Time,
};
